module.exports = __webpack_public_path__ + "img/losvega.2099808e.png";